import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useTheme } from "@kolmeo/ui-core";
const MAX_OPTION_CONTENT_HEIGHT = 200;
const DropdownContentContainer = ({ overlay, triggerHeight, optionsContainerProps, children }) => {
    const { palette } = useTheme();
    return (_jsx(Box, { position: overlay ? "absolute" : "relative", width: "100%", top: overlay ? triggerHeight + 8 : 0, backgroundColor: "white", left: 0, right: 0, marginTop: "4px", zIndex: overlay ? 999 : "auto", ...optionsContainerProps, maxHeight: MAX_OPTION_CONTENT_HEIGHT, overflow: "hidden", borderWidth: 1, borderColor: palette.border.default, borderRadius: 8, children: children }));
};
export default DropdownContentContainer;
